import * as core from '../../../../../../../core'

import { query } from './traceability-matrix-covered.query'

export const RESOURCE = {
  payload: {
    alias: 'traceability-matrix.covered',
    description: 'Count of requirements with passing tests and no failures',
    name: 'Traceability Matrix - Covered',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
